import styled from '@emotion/styled'
import { wrap as withStyle } from 'utils/styles'
import { Paragraph, Icon } from 'components/patterns'

export default withStyle(
  (props) => `
    display: flex;
    flex-grow: 1;

    ${Paragraph} {
      margin-top: 12px;
    }

    >div {
      flex-grow: 1;
    }
  `
)

export const StyledIcon = styled(Icon)((props) => {
  const { state } = props
  const { toastWarningBgColor, toastErrorBgColor } = props.theme
  const color = state === 'ERROR' ? toastErrorBgColor : toastWarningBgColor
  return `
    font-size: 18px;
    margin-top: 2px;
    margin-right: 10px;
    flex-shrink: 0; // ie11
    width: 18px;
    height: 18px;

    && {
      color: ${color};
    }

    // Ant Design icon SVG needs fill for the icon to be visible
    svg {
      fill: currentColor;
    }
  `
})

export const StyledSubheading = styled.div`
  margin-top: 8px;
  color: rgba(7, 7, 15, 0.7);
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 16px;
`

export const SaveOverlayContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const ListContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-bottom: 16px;
`

export const NotesContainer = styled.div`
  flex-shrink: 0;
  padding-top: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
`

export const StyledListHeader = styled.div`
  color: rgba(7, 7, 15, 0.7);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Arial;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  margin-top: 12px;
  margin-bottom: 8px;
`

export const StyledListItemText = styled.div`
  color: rgba(7, 7, 15, 0.7);
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`
